import { BufferAttribute, BufferGeometry, Line, LineBasicMaterial, Object3D } from "three";
import { linkRenderingParameters } from "./3d-rendering-parameters";

const { linkStopDistance } = linkRenderingParameters;

export function createLink3d(link: { source: string; target: string }): Object3D {
  const material = new LineBasicMaterial({
    vertexColors: false,
    color: 0x808080,
    transparent: true,
    opacity: 0.15,
  });
  const geometry = new BufferGeometry();
  geometry.setAttribute("position", new BufferAttribute(new Float32Array(2 * 3), 3));
  const line = new Line(geometry, material);
  return line;
}

export function updateLinkPosition3d(
  line: Object3D,
  pos: {
    start: { x: number; y: number; z: number };
    end: { x: number; y: number; z: number };
  },
  link: { source: any; target: any },
): boolean {
  const startR = linkStopDistance; // myGraph.nodeRelSize();
  const endR = linkStopDistance; // myGraph.nodeRelSize();
  const lineLenSquared = ["x", "y", "z"]
    .map((dim) => ((pos.end[dim] || 0) - (pos.start[dim] || 0)) ** 2)
    .reduce((acc, v) => acc + v, 0);
  const lineLen = Math.sqrt(lineLenSquared);

  const linePos = (line as Line).geometry.getAttribute("position") as any;

  // calculate coordinate on the node's surface instead of center
  const newPoints = Array.prototype.concat.apply(
    [],
    [startR / lineLen, 1 - endR / lineLen].map((t) =>
      ["x", "y", "z"].map((dim) => pos.start[dim] + (pos.end[dim] - pos.start[dim]) * t || 0),
    ),
  );
  linePos.set(newPoints);
  linePos.needsUpdate = true;
  return true;
}
